import { render } from "./Propos.vue?vue&type=template&id=1f7f06d1&scoped=true"
import script from "./Propos.vue?vue&type=script&lang=js"
export * from "./Propos.vue?vue&type=script&lang=js"

import "./Propos.vue?vue&type=style&index=0&id=1f7f06d1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7f06d1"]])

export default __exports__